var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import RichTextBlock from '../../common/components/RichText';
import { BigHeading } from '../../common/components/Text';
import { FlexJustifyContent, Grid, GridItem, } from '../../common/components/Grid';
var HeadingsGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var HeadingsSection = function (_a) {
    var titleText = _a.titleText, titleColor = _a.titleColor, titleHeadingLevel = _a.titleHeadingLevel, subtitle = _a.subtitle, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    return (React.createElement(HeadingsGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, justifyContent: FlexJustifyContent.CENTER, mb: [3, 4, null, 5] },
        React.createElement(GridItem, { w: [1, null, 10 / 12] },
            React.createElement(BigHeading, { "data-testid": "headings-section-title", as: titleHeadingLevel, color: titleColor, m: 0 }, titleText),
            subtitle && (React.createElement(RichTextBlock, { "data-testid": "headings-section-subtitle", dangerouslySetInnerHTML: { __html: subtitle }, mt: [2, 3, null, 4] })))));
};
HeadingsSection.defaultProps = {
    titleColor: 'text',
    titleHeadingLevel: 'h1',
    __legacy_shop_reboot_max_width: true,
};
HeadingsSection.propTypes = {
    /** Heading text. */
    titleText: PropTypes.string.isRequired,
    /** Heading color (string / hex code / rgba). */
    titleColor: PropTypes.string,
    /** Heading HTML tag name. */
    titleHeadingLevel: PropTypes.string,
    /** Text displayed below the heading. */
    subtitle: PropTypes.string,
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
export default HeadingsSection;
var templateObject_1;
